import FormViewer from './_src/formViewer.vue'
import FormWraper from './_src/formWraper.vue'
import FormItem from './_src/formItem.vue'
FormViewer.install = function(Vue) {
  Vue.component(FormViewer.name, FormViewer)
  Vue.component(FormWraper.name, FormWraper)
  Vue.component(FormItem.name, FormItem)
}

export default FormViewer